var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-content" }, [
    _c("h1", { staticClass: "title" }, [
      _vm._v("Calculadora de Valor da Terra Nua (VTN)")
    ]),
    _c(
      "p",
      [
        _vm._v(_vm._s(_vm.DESCRICAO)),
        _c(
          "el-card",
          { staticClass: "card-container", attrs: { shadow: "hover" } },
          [
            _c(
              "validation-observer",
              { ref: "validation", attrs: { tag: "form" } },
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required", name: "1" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-label", {
                                  attrs: { label: "Município:" }
                                }),
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "full-width input",
                                    class: { error: errors.length },
                                    model: {
                                      value: _vm.idMunicipio,
                                      callback: function($$v) {
                                        _vm.idMunicipio = $$v
                                      },
                                      expression: "idMunicipio"
                                    }
                                  },
                                  _vm._l(_vm.municipios, function(municipio) {
                                    return _c("el-option", {
                                      key: municipio.id,
                                      attrs: {
                                        label: municipio.nome,
                                        value: municipio.id
                                      }
                                    })
                                  }),
                                  1
                                ),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required", name: "2" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-label", {
                                  staticClass: "appLabel",
                                  attrs: {
                                    label: "Forma de pagamento:",
                                    required: _vm.required
                                  }
                                }),
                                _c(
                                  "el-select",
                                  {
                                    class: { error: errors.length },
                                    attrs: {
                                      placeholder: "Selecione",
                                      "value-key": "id"
                                    },
                                    model: {
                                      value: _vm.dadosForm.formaPagamento,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dadosForm,
                                          "formaPagamento",
                                          $$v
                                        )
                                      },
                                      expression: "dadosForm.formaPagamento"
                                    }
                                  },
                                  _vm._l(_vm.formaPagamentos, function(
                                    formaPagamento
                                  ) {
                                    return _c("el-option", {
                                      key: formaPagamento.id,
                                      attrs: {
                                        label: formaPagamento.value,
                                        value: formaPagamento.codigo
                                      }
                                    })
                                  }),
                                  1
                                ),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required", name: "3" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-label", {
                                  attrs: { label: "Período de carência (PC):" }
                                }),
                                _c(
                                  "el-select",
                                  {
                                    class: { error: errors.length },
                                    attrs: {
                                      placeholder: "Selecione",
                                      "value-key": "carencia",
                                      disabled: _vm.disableParcela
                                    },
                                    model: {
                                      value: _vm.dadosForm.carencia,
                                      callback: function($$v) {
                                        _vm.$set(_vm.dadosForm, "carencia", $$v)
                                      },
                                      expression: "dadosForm.carencia"
                                    }
                                  },
                                  _vm._l(_vm.carencias, function(carencia) {
                                    return _c("el-option", {
                                      key: carencia.id,
                                      attrs: {
                                        label: carencia.value,
                                        value: carencia.id
                                      }
                                    })
                                  }),
                                  1
                                ),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required", name: "4" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-label", {
                                  staticClass: "appLabel",
                                  attrs: {
                                    label: "Área requerida (ha):",
                                    required: _vm.required
                                  }
                                }),
                                _c("app-double-input", {
                                  staticClass: "input-redondo appInput",
                                  class: { error: errors.length },
                                  attrs: {
                                    name: "Área",
                                    precision: 4,
                                    onkeypress: _vm.onlyInputNumbers
                                  },
                                  model: {
                                    value: _vm.vtnRequest.areaRequerida,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.vtnRequest,
                                        "areaRequerida",
                                        $$v
                                      )
                                    },
                                    expression: "vtnRequest.areaRequerida"
                                  }
                                }),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required", name: "5" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-label", {
                                  staticClass: "appLabel",
                                  attrs: {
                                    label: "Número de parcelas anuais (n):",
                                    required: _vm.required
                                  }
                                }),
                                _c(
                                  "el-select",
                                  {
                                    class: { error: errors.length },
                                    attrs: {
                                      placeholder: "Selecione",
                                      "value-key": "id",
                                      disabled: _vm.disableParcela
                                    },
                                    model: {
                                      value: _vm.dadosForm.qntdParcelas,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dadosForm,
                                          "qntdParcelas",
                                          $$v
                                        )
                                      },
                                      expression: "dadosForm.qntdParcelas"
                                    }
                                  },
                                  _vm._l(_vm.parcelasComputed, function(
                                    parcela
                                  ) {
                                    return _c("el-option", {
                                      key: parcela.id,
                                      attrs: {
                                        label: parcela.value,
                                        value: parcela.id
                                      }
                                    })
                                  }),
                                  1
                                ),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col button" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "no-padding",
                          attrs: { type: "text" },
                          on: { click: _vm.limpar }
                        },
                        [_vm._v("   Limpar")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "el-button",
                          attrs: { type: "primary" },
                          on: { click: _vm.calcular }
                        },
                        [
                          _c("i", { staticClass: "fal fa-credit-card" }),
                          _vm._v("  Calcular")
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          ],
          1
        ),
        _vm.dadosVtn
          ? _c("confirmar-dados", {
              attrs: { dadosVtn: _vm.dadosVtn, exibeObs: true }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d204cba8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d204cba8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/SimularVtn.vue
// module id = null
// module chunks = 